/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeHistoryDtoEmployee
 */
export interface DeferredIncomeHistoryDtoEmployee {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoEmployee
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoEmployee
   */
  name: string;
}

export function DeferredIncomeHistoryDtoEmployeeFromJSON(json: any): DeferredIncomeHistoryDtoEmployee {
  return DeferredIncomeHistoryDtoEmployeeFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryDtoEmployeeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryDtoEmployee {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function DeferredIncomeHistoryDtoEmployeeToJSON(value?: DeferredIncomeHistoryDtoEmployee | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
